module.exports = __webpack_public_path__ + "media/images/przedszkole4-0e76e6d1dd588fa9a9f2f53197f09672.png";